import { useState } from "react";
import React from "react";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from 'axios'
import { toast } from 'react-toastify';

const initialState = {
  name: "",
  email: "",
  phone: "1",
  message: ""
};

export const Contact = (props) => {
  const [{ name, email, phone, message}, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handlePhoneChange = (e) =>{
    let phone = "+" + e;
    setState((prevState) => ({ ...prevState, ['phone']: phone }));
  };

  const clearState = () => {
    setState({ ...initialState })
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const showToast = () => {
    toast.success('Form has been submitted', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
      });
  };

  const errorToast = () => {
    toast.error('Form submission failed', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined
      });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    const server_url = process.env.REACT_APP_ENVIRONMENT === 'development'
    ? process.env.REACT_APP_API_SERVER_URL_DEV
    : process.env.REACT_APP_API_SERVER_URL;

    const data = {
      'name' : name,
      'email' : email,
      'phone' : phone,
      'message': message
    }

    axios.post(server_url + "/submit_faq", data)
    .then(function (response) {
      showToast();
    })
    .catch(function (error) {
      errorToast();
    })
    .finally(function(){
      clearState();
      setIsSubmitting(false);
    });
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        value={name}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>

                <div class = "row">
                  <div className="col-md-12">
                    <div className="form-group">
                    <PhoneInput
                      inputProps={{
                        id: 'phone',
                        name: 'phone',
                        required: true
                      }}
                      country={'us'}
                      countryCodeEditable = {false}
                      enableSearch = {true}
                      autoFormat = {true}
                      value={phone}
                      onChange={handlePhoneChange}
                    />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg" disabled={isSubmitting}>
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Office (VO)
                </span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: props.data ? props.data.address : "...Loading",
                  }} />
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                    <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? (
                    <a href= {props.data.whatsapp} className="phone-link">{props.data.phone}</a>
                  ) : (
                    "...Loading"
                  )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "...Loading"}
              </p>
            </div>
          </div>
          {/* <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Glora Agro International
          </p>
        </div>
      </div>
    </div>
  );
};
